import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-security-page',
	templateUrl: './security-page.component.html',
	styleUrls: ['./security-page.component.sass']
})
export class SecurityPageComponent implements OnInit {

	constructor(private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('security')
	}

}
